export default "__VITE_ASSET__m6AXMXT9__"